import { pluralize } from '@/helpers/text.utils'
import { useEffect } from 'react'
import { TResultStatus } from './QuizPopup'

export const getTime = (time: string) => {
    const [minutes, seconds] = time.split(':')
    return {
        time: parseInt(minutes) * 60 + parseInt(seconds),
        minutes: parseInt(minutes),
        seconds: parseInt(seconds)
    }
}

export const useDisableScroll = () => {
    useEffect(() => {
        const body = document.querySelector('body')

        body.style.overflow = 'hidden'

        return () => {
            body.style.overflow = 'initial'
        }
    }, [])
}

export const getTimeAsString = (minutes: number, seconds: number) => {
    const m = `${minutes} ${pluralize(minutes, 'минута', 'минуты', 'минут')}`

    if (seconds) {
        return `${m} и ${seconds} ${pluralize(seconds, 'секунда', 'секунды', 'секунд')}`
    }

    return m
}

export const getFinishDescription = (status: TResultStatus, correctCount: number, questionsCount: number) => {
    const descriptionByResult = {
        idle: () => '',
        success: (n: number) =>
            `Поздравляем, вы успешно прошли тест, ответив правильно на ${n} из ${questionsCount} ${pluralize(
                questionsCount,
                'вопроса',
                'вопросов',
                'вопросов'
            )}. Вне всякого сомнения, самое важное, что вы получили сегодня, — это знания, которые сможете применять для себя и своих клиентов. Отличная работа!`,
        failed: (n: number) =>
            ` К сожалению, вы ответили правильно на ${n} из ${questionsCount} ${pluralize(
                questionsCount,
                'вопроса',
                'вопросов',
                'вопросов'
            )}, но не расстраивайтесь! Впереди еще море интересных вебинаров и лекций от ГК МЕГАМИКС. Следите за новостями!`
    }

    return descriptionByResult[status](correctCount)
}
